import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询航班
export function queryFlights(data) {
  return request({
    url: URL.booking.queryFlights,
    method: 'post',
    data
  })
}
// 查询航班
export function queryCharterAndPalletStatistics(data) {
  return request({
    url: URL.booking.queryCharterAndPalletStatistics,
    method: 'post',
    data
  })
}

// 获取航班
export function getFlight(uuid) {
  return request({
    url: URL.booking.getFlight,
    method: 'get',
    params: { uuid }
  })
}

// 更新航班
export function updateFlight(data, params) {
  return request({
    url: URL.booking.updateFlight,
    method: 'put',
    data,
    params
  })
}
// 更新航班
export function updateJobUld(data) {
  return request({
    url: URL.booking.updateJobUld,
    method: 'post',
    data
  })
}

// 根据航班编号和分公司Id来判断是否有航班明细信息
export function isThereFlight(params) {
  return request({
    url: URL.booking.isThereFlight,
    method: 'get',
    params
  })
}

// 根据航班编号和分公司Id来删除当前时间以后的航班信息，重新生成新的航班信息
export function delFlights(params) {
  return request({
    url: URL.booking.delFlights,
    method: 'delete',
    params
  })
}

// 根据航班描述生成航班
export function generateFlights() {
  return request({
    url: URL.booking.generateFlights,
    method: 'post'
  })
}
